import { default as en } from './en.json'
import { default as uk } from './uk.json'

export const Locales = { en, uk }
